import { render, staticRenderFns } from "./CallDuration.vue?vue&type=template&id=c00909cc&scoped=true"
import script from "./CallDuration.vue?vue&type=script&lang=js"
export * from "./CallDuration.vue?vue&type=script&lang=js"
import style0 from "./CallDuration.vue?vue&type=style&index=0&id=c00909cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c00909cc",
  null
  
)

export default component.exports